import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlSerializer } from '@angular/router';
import { BusinessServicesComponent } from './pages/upscapital/business-services/business-services.component';
import { ContactUsComponent } from './pages/upscapital/contact-us/contact-us.component';
import { ContinuousCustomsBondsComponent } from './pages/upscapital/business-services/continuous-customs-bonds/continuous-customs-bonds.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ContinuousCustomsBondsApplicationComponent } from './pages/upscapital/business-services/continuous-customs-bonds-application/continuous-customs-bonds-application.component';
import { CodComponent } from './pages/upscapital/business-services/cod/cod.component';
import { MerchantServicesComponent } from './pages/upscapital/business-services/merchant-services/merchant-services.component';
import { PaymentServicesComponent } from './pages/upscapital/business-services/payment-services/payment-services.component';
import { PrivacyNoticeComponent } from './pages/upscapital/privacy-notice/privacy-notice.component';
import { ProductDisclosureComponent } from './pages/upscapital/product-disclosures/product-disclosures.component';
import { TermAndConditionsComponent } from './pages/upscapital/term-and-conditions/term-and-conditions.component';
import { DemoFormPageComponent } from './pages/upscapital/demoformPage/demoformPage.component';
import { OptoutComponent } from './pages/upscapital/optout/optout.component';
import { CaliforniaPrivacyComponent } from './pages/upscapital/california-privacy/california-privacy.component';

const routes: Routes = [
  {path:'business-services',component:BusinessServicesComponent},
  {path:'business-services/continuous-customs-bonds',component:ContinuousCustomsBondsComponent},
 // {path:'business-services/continuous-customs-bonds/application',component:ContinuousCustomsBondsApplicationComponent},
  {path:'business-services/payment-services/cod',component:CodComponent},
  {path:'business-services/payment-services/merchant-services',component:MerchantServicesComponent},
  {path:'business-services/payment-services',component:PaymentServicesComponent},
  {path:'privacy-notice',component:PrivacyNoticeComponent},
  {path:'us-product-disclosures',component:ProductDisclosureComponent},
  {path:'product-terms-and-conditions',component:TermAndConditionsComponent},
  {path:'contact-us',component:ContactUsComponent},
  {path:'assets',component:ContactUsComponent},
  {path:'opt-out',component:OptoutComponent},
  {path:'california-privacy-notice',component:CaliforniaPrivacyComponent},
  {path:'**',component: RedirectComponent}
];

export function malformedUriHandler(error: URIError, urlSerializer: UrlSerializer, url: string) {
  return urlSerializer.parse('/404');
}

@NgModule({
  imports: [RouterModule.forRoot(routes, {
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
